import type { FC } from 'react';
import { lazy, Suspense } from 'react';

import * as Sentry from '@sentry/react';

import { useAuth } from 'shared/lib/auth/useAuth';

import { useInkeepConfig } from './useInkeepConfig';

const InkeepChatButtonComponent = lazy(() =>
  import('@inkeep/cxkit-react').then((module) => ({
    default: module.InkeepChatButton,
  })),
);

export const InkeepChat: FC = () => {
  const { isAuthenticated } = useAuth();
  const config = useInkeepConfig();

  if (!(isAuthenticated && config.baseSettings?.apiKey)) {
    return null;
  }

  return (
    <Sentry.ErrorBoundary fallback={<></>}>
      <Suspense fallback={null}>
        <InkeepChatButtonComponent {...config} />
      </Suspense>
    </Sentry.ErrorBoundary>
  );
};
